import { render, staticRenderFns } from "./TemplateFlexibleSteps.vue?vue&type=template&id=18de1d1d&scoped=true&"
import script from "./TemplateFlexibleSteps.vue?vue&type=script&lang=js&"
export * from "./TemplateFlexibleSteps.vue?vue&type=script&lang=js&"
import style0 from "./TemplateFlexibleSteps.vue?vue&type=style&index=0&id=18de1d1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18de1d1d",
  null
  
)

export default component.exports